import React from 'react';
import { useNavigate } from '@tanstack/react-router';
import ChatInterface from '@/components/ChatInterface';
import { useInventory } from '@/context/InventoryContext';
import { useProfile } from '@/context/ProfileContext';
import UpgradePrompt from '@/components/UpgradePrompt';

const RemyPage: React.FC = () => {
  const { isPremium } = useProfile();
  const navigate = useNavigate();
  const {
    displayInventory,
    isSynced,
    recommendContext,
    setRecommendContext,
    wineBriefContext,
    setWineBriefContext,
    handleAddToCellarFromChat,
    setSelectedWine,
  } = useInventory();

  if (!isPremium) {
    // onDismiss gives the screen an action on platforms with no purchase path,
    // where the upgrade button is hidden and nothing else here is interactive.
    return <UpgradePrompt variant="fullscreen" feature="remy" onDismiss={() => navigate({ to: '/cellar' })} />;
  }

  return (
    <ChatInterface
      inventory={displayInventory}
      isSynced={isSynced}
      recommendContext={recommendContext}
      onRecommendContextConsumed={() => setRecommendContext(null)}
      wineBriefContext={wineBriefContext}
      onWineBriefContextConsumed={() => setWineBriefContext(null)}
      onAddToCellar={handleAddToCellarFromChat}
      onViewWine={setSelectedWine}
    />
  );
};

export default RemyPage;
